import styled from 'styled-components';

export const Wrapper = styled.div`
  font-family: sans-serif;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 24px;
`;

export const MainTitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 24px 0;
  flex-direction: row;
  margin-top: 12px;
`;

export const MainTitle = styled.h2`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 20px;
  font-family: rubik;
  color: #063856;
  padding-left: 12px;
`;

export const SectionWrapper = styled.div`
  margin-bottom: 24px;

  &:not(:first-child) {
    border-top: 1px solid #eee;
    padding-top: 16px;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    justify-content: space-between;
  }
`;

export const SectionTitle = styled.h3`
  font-weight: 500;
  font-size: 18px;
  font-family: rubik;
  color: #2f3741;
`;

export const ViewPhotosLink = styled.a`
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
  margin-left: 48px;
  &:hover {
    text-decoration: underline;
  }
`;

export const ItemsContainer = styled.div`
  display: block;
`;

export const Column = styled.div`
  flex: 1;
`;

export const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  span {
    margin-left: 8px;
  }
`;

export const ItemText = styled.span`
  font-size: 16px;
  font-family: rubik;
  color: #2f3741;
`;
